import React from 'react';
export function Footer() {
  const links = [{
    name: 'Celebrate',
    href: '#celebrate'
  }, {
    name: 'Honor',
    href: '#honor'
  }, {
    name: 'Support',
    href: '#support'
  }, {
    name: 'Event',
    href: '#event'
  }, {
    name: 'Flyer',
    href: '#flyer'
  }];
  return <footer className="bg-white py-16 border-t border-gray-200" data-id="element-56">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        {/* Top section with logos and navigation */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12" data-id="element-58">
          {/* Left: Logos and tagline */}
          <div className="lg:col-span-1" data-id="element-59">
            <div className="flex items-center gap-4 mb-6" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/4tAPPhhSxFFzHh1MdQYkPw/Good_Father_Project.png" alt="Good Father Project" className="h-12 w-auto" data-id="element-61" />
              <img src="https://cdn.magicpatterns.com/uploads/jiXzHYbTVX6No9MUBUqJKf/Fatherhood_Initiative.png" alt="Fatherhood Matters" className="h-12 w-auto" data-id="element-62" />
            </div>
            <p className="text-gray-600 text-sm leading-relaxed max-w-sm" data-id="element-63">
              Strengthening families through reflection, presence, and community
              partnership. An initiative dedicated to the quiet, vital work of
              fatherhood.
            </p>
          </div>

          {/* Middle: Navigation */}
          <div data-id="element-64">
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-65">
              Navigation
            </h3>
            <nav className="flex flex-col space-y-3" data-id="element-66">
              {links.map(link => <a key={link.name} href={link.href} className="text-gray-700 hover:text-[#1e5631] text-sm transition-colors" data-id="element-67">
                  {link.name}
                </a>)}
            </nav>
          </div>

          {/* Right: Contact */}
          <div data-id="element-68">
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-69">
              Contact
            </h3>
            <a href="mailto:info@goodfatherproject.org" className="text-gray-700 hover:text-[#1e5631] text-sm transition-colors" data-id="element-70">
              info@goodfatherproject.org
            </a>
          </div>
        </div>

        {/* Bottom section */}
        <div className="pt-8 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-71">
          <p className="text-gray-400 text-sm" data-id="element-72">
            © 2026 The Good Father Project. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-400" data-id="element-73">
            <span data-id="element-74">
              Web Design by{' '}
              <a href="https://travishellstrom.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1e5631] transition-colors" data-id="element-75">
                Travis Hellstrom
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>;
}